<template>
  <div id="pay">
    <el-dialog
      :visible.sync="payDialogShow"
      width="35%"
      :before-close="handleClose"
      title="请选择"
    >
      <div class="pay-qrCode display-flex">
        <el-button type="payButton" size="medium" round @click="goToPay">
          立即支付
        </el-button>
        <el-button type="doneButton" size="medium" round @click="payDone">
          支付完成
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { encryptByDES } from '../setup/common';
import user from '../setup/user';
import routerTo from '@/router/routerTo';
export default {
  props: {
    orderId: String,
    orderAmount: String,
    payDialogShow: Boolean,
    comeFrom: String,
  },
  data() {
    return {
      /*payDialogShowGet: true,*/
    };
  },
  computed: {
    /*
    payShow() {
      return this.payDialogShow;
    },*/
  },
  mounted() {},
  created() {
    // this.payDialogShowGet = this.payDialogShow;
  },
  methods: {
    handleClose() {
      console.log('关闭', this.payDialogShow);
      this.$emit('payPrenterShow');
    },
    goToPay() {
      let encodeOrderCode = encryptByDES(this.orderId);
      let currentUser = user.getUser();
      let sessionId = currentUser.sessionId;
      let product_code = '';
      console.log('this.comefrom', this.comeFrom);
      if (this.comeFrom == 'mall') {
        product_code = process.env.VUE_APP_MALL_PRODUCT_CODE;
      } else {
        product_code = process.env.VUE_APP_TICKET_PRODUCT_CODE;
      }
      //http://124.127.40.91:22060  https://gwpay.danjwlyq.com
      let urlAll =
        process.env.VUE_APP_PAY_URL +
        '?ref_appkey=' +
        process.env.VUE_APP_CONFIG_APP_KEY +
        '&merchant_code=' +
        process.env.VUE_APP_MALL_MERCHANT_CODE +
        '&product_code=' +
        product_code +
        '&sessionid=' +
        sessionId +
        '&order_code=' +
        this.orderId +
        '&order_amount=' +
        this.orderAmount +
        '&success_url=' +
        encodeURIComponent(process.env.VUE_APP_DOMAIN_URL + '/paySuccess') +
        '&error_url=' +
        encodeURIComponent(process.env.VUE_APP_DOMAIN_URL + '/payError');
      window.open(urlAll); //  跳转链接
    },
    payDone() {
      this.payDialogShow = false;
      this.$emit('payPrenterShow');
      // console.log('', this.$router.history);
      // if (this.comeFrom == 'mall') {
      //   this.$router.push({ path: '/account/mall-order' });
      // } else {
      //   this.$router.replace({ path: '/account/ticket-order' });
      // }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.pay-qrCode {
  width: 360px;
  margin: 0 auto;
  text-align: left;
  .el-button--payButton {
    width: 150px;
    color: white;
    background-color: #31a775;
  }
  .el-button--doneButton {
    width: 150px;
    color: white;
    background-color: #f15b49;
  }
}
</style>
